import { render } from "./UserForgotPassword.vue?vue&type=template&id=852e5cba"
import script from "./UserForgotPassword.vue?vue&type=script&lang=js"
export * from "./UserForgotPassword.vue?vue&type=script&lang=js"

import "./UserForgotPassword.vue?vue&type=style&index=0&id=852e5cba&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__